import { CIcon } from '~/icons/types'

export const ciRedo: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M14 8a1 1 0 0 0 1 1h6c.011 0 .02-.006.03-.006.063-.002.121-.023.183-.037.067-.015.136-.022.197-.049.038-.017.069-.049.106-.071.075-.047.15-.092.21-.156.005-.006.013-.008.018-.013.029-.032.039-.072.062-.106.047-.067.094-.131.123-.209.025-.065.03-.132.04-.199.008-.053.031-.1.031-.154V2a1 1 0 1 0-2 0v3.753l-1.339-1.205a10.046 10.046 0 0 0-6.05-2.481 10.043 10.043 0 0 0-6.29 1.788 10.044 10.044 0 0 0-3.84 5.293 10.044 10.044 0 0 0 .251 6.535 10.042 10.042 0 0 0 4.235 4.981 10.05 10.05 0 0 0 6.409 1.3 10.043 10.043 0 0 0 5.841-2.939 10.033 10.033 0 0 0 2.776-5.92 1 1 0 0 0-.889-1.1.994.994 0 0 0-1.1.889 8.035 8.035 0 0 1-2.222 4.736 8.035 8.035 0 0 1-4.673 2.352 8.029 8.029 0 0 1-5.127-1.04 8.04 8.04 0 0 1-3.389-3.985 8.038 8.038 0 0 1-.2-5.228 8.05 8.05 0 0 1 3.074-4.235 8.016 8.016 0 0 1 5.032-1.43c1.781.1 3.5.805 4.832 1.978L18.396 7H15a1 1 0 0 0-1 1Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'redo',
  type: 'regular'
}
